<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Button } from '@/components/ui';
import { useFlag } from '@/composables';
import type { LanguageCode } from '@/types';

interface Props {
  language?: LanguageCode;
  withFlags?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  language: 'en',
  withFlags: true,
});

const { t } = useI18n();
const { getFlag } = useFlag();

const getLang = (language: string) => language.split('-')[0].toLowerCase();
</script>

<template>
  <router-link :to="{ name: 'locale', params: { locale: props.language } }">
    <Button class="gap-2 font-sans-secondary text-xs uppercase tracking-wider" variant="ghost">
      <img v-if="withFlags" class="size-6 rounded-full" :src="getFlag(props.language)" alt="" />
      {{ t(`language-selector-dialog.languages.${getLang(props.language)}`) }}
    </Button>
  </router-link>
</template>
